import { Card } from "@payping/web-components";
import React from "react";
import { FormInstance } from "@payping/web-components/components/Form/types";
import ManualAddition from "./manualAddition";
import { SettlementRowType } from "./secondStep";

interface Props {
  form: FormInstance<SettlementRowType>;
  loadingList: boolean;
}
const ManualRequest: React.FC<Props> = (props: Props) => {
  const { form, loadingList } = props;

  return (
    <Card.Ant>
      <ManualAddition loadingList={loadingList} form={form} />
    </Card.Ant>
  );
};

export default ManualRequest;
